import React from "react";
import {
  Box,
  Typography,
  Divider,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Chip,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import moment from "moment";
import { mustDoThingsPageProps } from "./mustDoThings";

const MustDoDetailPage: React.FC<mustDoThingsPageProps> = ({
  mustDoThingsObj,
  handleClose,
}) => {
  if (!mustDoThingsObj) {
    return (
      <Box
        sx={{
          width: "100%",
          maxWidth: "1500px",
          margin: "auto",
          mt: "10%",
          p: 3,
          textAlign: "center",
          borderRadius: 2,
          boxShadow: 3,
          bgcolor: "background.paper",
        }}
      >
        <Typography variant="h5" color="primary" fontWeight="bold" mb={2}>
          Banner Details
        </Typography>
        <Typography variant="body1" color="textSecondary">
          No Banner data available.
        </Typography>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="primary"
          sx={{ mt: 3 }}
        >
          Go Back
        </Button>
      </Box>
    );
  }

  const {
    _id,
    title,
    type,
    description,
    isDeleted,
    websiteUrl,
    slug,
    images,
  } = mustDoThingsObj;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1200px",
        margin: "auto",
        mt: 5,
        p: 3,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
      }}
    >
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" color="primary" fontWeight="bold">
          Must Do Details Detail
        </Typography>
        <IconButton onClick={handleClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </Box>

      <Grid item xs={12} md={6} textAlign="left">
        <CardContent>
          <Typography variant="h6" fontWeight="bold">
            <strong style={{ color: "#000" }}> Title: </strong> {title}
            <span>
              {!isDeleted ? (
                <Tooltip title="Active">
                  <IconButton aria-label="status" style={{ color: "#039487" }}>
                    <TaskAltIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Deleted">
                  <IconButton aria-label="status" style={{ color: "#ff9966" }}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              )}
            </span>
          </Typography>

          <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
            <strong style={{ color: "#000" }}> Website URL: </strong>
            <a
              href={websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "none" }}
            >
              {websiteUrl || "N/A"}
            </a>
          </Typography>

          <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
            <strong style={{ color: "#000" }}>Type: </strong> {type}
          </Typography>

          <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
            <strong style={{ color: "#000" }}>Slug: </strong> {slug}
          </Typography>

          <Typography variant="body1" color="textSecondary" sx={{ fontSize: "1.2rem" }}>
            <strong style={{ color: "#000" }}>Description: </strong> {description}
          </Typography>
        </CardContent>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {images && images?.length > 0 ? (
            <Grid container spacing={2}>
              {images?.map((img, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Card>
                    <CardMedia
                      component="img"
                      image={img?.image}
                      alt={img?.businessName || "Must Do Image"}
                      sx={{
                        width: "100%",
                        height: 200,
                        objectFit: "cover",
                      }}
                    />
                    <CardContent>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Business: {img?.businessName || "N/A"}
                      </Typography>
                      <Typography variant="subtitle2" fontWeight="bold">
                        Explore: {img?.exploreName || "N/A"}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No images available.
            </Typography>
          )}
        </Grid>
      </Grid>



      <Divider sx={{ my: 3 }} />

      <Box display="flex" justifyContent="flex-end">
        <Button onClick={handleClose} variant="contained" color="primary">
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default MustDoDetailPage;